import { Card, Col, DatePicker, Empty, Row, Table } from 'antd';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Query } from 'react-apollo';

import { DateRange } from '../../types/base';
import { AccountTransaction, AccountTransactionSource, AccountType, UserAccount } from '../../types/userAccount';

export const USER_ACCOUNT_TRANSACTION_QUERY = gql`
  query GetUserAccountsTransaction($ids: [ID]) {
    users(ids: $ids) {
      accounts {
        accountType
        balance
        transactions {
          remark
          source
          amount
          createdAt
        }
      }
    }
  }
`;

interface Props {
  userId: number;
}

interface State {
  dateRange: DateRange;
  selectedMarketingActivityFilter: number;
}

export class AccountTransactionRecords extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      dateRange: {
        from: moment().subtract(6, 'days').toDate(),
        to: new Date(),
      },
      selectedMarketingActivityFilter: 0,
    };
  }
  getTransactionsList(accounts: UserAccount[], loading: boolean) {
    const account = accounts.find(account => account.accountType === AccountType.POINT);
    if (!account) return null;

    const { dateRange } = this.state;
    const from = moment(dateRange.from);
    const to = moment(dateRange.to);

    const { transactions } = account;

    const transactionInDateRange = transactions.filter(transaction =>
      moment(transaction.createdAt).isBetween(from, to),
    );

    const addIdTransactionInDateRange = transactionInDateRange
      .map((transaction, index) => {
        transaction.id = index;
        return transaction;
      })
      .sort((a, b) => {
        return moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf();
      });
    return (
      <Table<AccountTransaction>
        columns={[
          {
            title: '日期',
            key: 'date',
            render: record => moment(record && record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
          },
          {
            title: '积分描述',
            key: 'status',
            render: record => (record && record.remark) || '',
          },
          {
            title: '积分数量',
            key: 'quantity',
            render: record => (record && record.amount) || 0,
          },
          {
            title: '来源',
            key: 'from',
            render: record => {
              if (!record) {
                return '其他';
              }
              if (record.source === AccountTransactionSource.CLOCK_IN) {
                return '打卡';
              }
              if (record.source === AccountTransactionSource.SLM) {
                return '分销';
              }
              if (record.source === AccountTransactionSource.CHECK_IN) {
                return '签到';
              }
              return '其他';
            },
          },
        ]}
        loading={loading}
        dataSource={addIdTransactionInDateRange}
        rowKey={record => `${record.id}`}
        pagination={false}
      />
    );
  }

  getPointAccountBalance(accounts: UserAccount[]) {
    const account = accounts.find(account => account.accountType === AccountType.POINT);
    return (account && account.balance) || 0;
  }
  render() {
    const { userId } = this.props;
    const { dateRange } = this.state;
    const ids = [Number(userId)];
    return (
      <Query query={USER_ACCOUNT_TRANSACTION_QUERY} variables={{ ids }}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const [user] = data.users || {};
          const accounts = (user && user.accounts) || [];
          return (
            <div>
              <Card bordered={false}>
                <Row gutter={12}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    累计积分
                  </Col>
                  <Col span={7}>{this.getPointAccountBalance(accounts)}</Col>
                </Row>
                <Row gutter={24} style={{ marginTop: 10 }}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    筛选时间
                  </Col>
                  <Col span={19}>
                    <DatePicker.RangePicker
                      value={[moment(dateRange.from), moment(dateRange.to)]}
                      ranges={{
                        今天: [moment(), moment()],
                        本周: [moment().startOf('week'), moment().endOf('week')],
                        上周: [
                          moment().startOf('week').subtract(1, 'week'),
                          moment().endOf('week').subtract(1, 'week'),
                        ],
                      }}
                      onChange={dates =>
                        this.setState({
                          dateRange: {
                            from: moment(dates[0]).startOf('day').toDate(),
                            to: moment(dates[1]).endOf('day').toDate(),
                          },
                        })
                      }
                    />
                  </Col>
                </Row>
              </Card>
              {this.getTransactionsList(accounts, loading)}
            </div>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/user/AccountTransactionRecords.tsx